export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-power-4dc4a2da94f65c9a1b200700c82003ab.svg";